/**
 * CB-WI5's two fields (`claimed_at`, `incarnation`), formatted for the connections table.
 *
 * <p>Pure, and separate from `ConnectionsPage.tsx`, for the reason every other helper beside it
 * is: `incarnationTag` has one real decision in it (show nothing for the first wearer of a name)
 * and a component test cannot isolate that from rendering.
 */

import { formatRelative } from '@/lib/format'

export interface IncarnationTag {
  /** `#<n>` — the short badge label. */
  label: string
  /** Spells out why it matters: a peer still holding the previous holder's identity is stale. */
  title: string
}

/**
 * `undefined` for the first claimant (`incarnation` 1, or the null the single-row replies carry —
 * nothing was released yet, so there is nothing to flag) — a badge on every ordinary row would be
 * noise, not information. From the second claimant on, the tag names how many times the name has
 * changed hands, because a peer that has been talking to `mail` since before it was released is
 * now talking to nobody.
 */
export function incarnationTag(incarnation: number | null): IncarnationTag | undefined {
  if (incarnation === null || incarnation <= 1) return undefined
  return {
    label: `#${incarnation}`,
    title: `this name has been claimed ${incarnation} times; a peer talking to an earlier holder should check`,
  }
}

/** `claimed 4 minutes ago` — the row's secondary line, next to (not instead of) `created_at`. */
export function claimedLabel(iso: string, now: number): string {
  return `claimed ${formatRelative(iso, now)}`
}
